import React from "react";
import _ from "underscore";
import { LazyLoadImage } from "../../../core/atoms/atoms";
import { PlayTriangle } from "./playTriangle";

import "./clippedVideoPlaceholder.scss";

interface OwnProps {
  imageUrl: string;
  alt: string;
  onClick?: (e?: React.MouseEvent<HTMLDivElement>) => void;
}

export const ClippedVideoPlaceholder = ({ imageUrl, onClick, alt }: OwnProps) => (
  <div className="clipped-embedded-video" onClick={onClick}>
    <LazyLoadImage src={imageUrl} alt={alt} />
    <PlayTriangle size={130} />
  </div>
);
